import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

const TAGS_SEARCH_QUERY = gql`
  query TagsSearch($search: String) {
    tags(search: $search) {
      id
      name
      slug
    }
  }
`;

export interface TagItem {
  id: string;
  name: string;
  slug: string;
}

const MIN_SEARCH_LENGTH = 1;

export function useTagsSearch(search: string) {
  const normalized = search.trim().toLowerCase();
  const effectiveSearch =
    normalized.length >= MIN_SEARCH_LENGTH ? normalized.replace(/\s+/g, '-') : '';

  const { data, loading } = useQuery<{ tags: TagItem[] }>(TAGS_SEARCH_QUERY, {
    variables: { search: effectiveSearch || null },
    skip: !effectiveSearch,
    fetchPolicy: 'network-only',
  });

  const tags = data?.tags ?? [];
  return { tags, loading };
}
